import styled from 'styled-components';
import { Colors } from '../../utils/style/colors';

export default styled.div`
	width: 1px;
	height: 36px;
	margin: 7px 5px;
	background-color: ${props => props.color || Colors.gray20};
`;